import React, { useEffect, useRef, useState } from "react";

import { connect } from "react-redux";
import { includes, map } from "lodash";

import Emitter from "../../utils/Emitter";

import { getCountryList } from "../../actions/defaultDataAction";

import { default as ReactSelect, components } from "react-select";

import ButtonAdminpanel from "../../components/ButtonAdminpanel";
import DropDown from "../../components/DropDown";
import InputField from "../../components/InputField";
import DateRangePickerField from '../../components/DateRangePickerField';
import { format } from 'date-fns';
import Tooltips from "../../components/Tooltips";
import ToolipsCustom from "../../components/ToolipsCustom";
import ButtonAdd from "../../components/ButtonAdd";
import { useAuth } from "../../AuthProvider";
import defaultValues from "../../constant/defaultValues";
import { getCompanyListByTradeMode } from "@/actions/memberAction";
import moment from "moment";

const AllAdminInquiriesFilter = (props) => {

  const { isSuperAdmin, isViewer, isInqUser } = useAuth();
  const { admin } = defaultValues;

  const findByOptions = [
    {
      label: "All",
      value: "All",
    },
    {
      label: "Supplier",
      value: "Supplier",
    },
    {
      label: "Logistic Partner",
      value: "Logistic_Partner",
    },
  ];

  const inqType = [
    {
      label: "All",
      value: "All",
    },
    {
      label: "Real",
      value: "real",
    },
    {
      label: "Mock",
      value: "mock",
    },
  ];

  const CustomOption = ({ innerRef, innerProps, isSelected, label }) => (
    <div
      ref={innerRef}
      {...innerProps}
      style={{ display: "flex", alignItems: "center" }}
      className={isSelected ? "div-item-selected" : "div-item-unselected"}
    >
      {isSelected && (
        <div className={` item-selected `}>
          <label style={{ marginLeft: "8px" }}>{label}</label>
        </div>
      )}
      {!isSelected && (
        <div className={` item-selected2 `}>
          <label style={{ marginLeft: "8px" }}>{label}</label>
        </div>
      )}
    </div>
  );

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      "&:hover": {},
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#4c9bdb", // Background of the selected multi-value items
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#fff", // Color of the text inside the multi-value
      fontSize: "20px",
    }),

    multiValueRemove: (provided) => ({
      ...provided,
      color: "#df0024", // Remove button color
      ":hover": {
        backgroundColor: "#df0024", // Background color on hover for the remove button
      },
    }),
  };


  // console.log("props.fordate =================== ", props.fordate)

  const [findByInqTypeVal, setInqTypeVal] = useState(isViewer ? inqType[2] : inqType[1]);

  const [findByOptionVal, setFindByOptionVal] = useState(findByOptions[0]);
  const [countryList, setCountryList] = useState([]);

  const [country, setSelectedCountry] = useState([]);
  // const [isFilteredData, setFilterData] = useState(false);
  const [searchedTxt, setSearchedTxt] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const initialFilterRef = useRef(true);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedAssignToMember, setSelectedAssignToMember] = useState(null);
  const [companyList, setCompanyList] = useState([]);

  const today = new Date();

  const defaultCalendarValue = [
    new Date(today.getFullYear(), today.getMonth() - 1, 1),
    new Date(today.getFullYear(), today.getMonth(), 1)
  ];

  const [placehoderTxt, setPlaceHoderTxt] = useState("Search By Company Name, Contact Person, Email, Product, Inquiry ID, Industry/Commodity");


  const customMemberFilter = (option, searchTxt) =>
    option.data.email.toLowerCase().includes(searchTxt.toLowerCase()) ||
    option.data.label.toLowerCase().includes(searchTxt.toLowerCase());


  const handleFindByChange = (val) => {
    setFindByOptionVal(val);
    if (val) {
      let filterType = val.value;
      if (filterType === "Supplier") {
        setPlaceHoderTxt("Search By Company Name, Contact Person, Email, Product, Inquiry ID, Industry");
      } else if (filterType === "Logistic_Partner") {
        setPlaceHoderTxt("Search By Company Name, Contact Person, Email, Inquiry ID, Commodity");
      } else {
        setPlaceHoderTxt("Search By Company Name, Contact Person, Email, Product, Inquiry ID, Industry/Commodity");
      }
    }
  };

  const handleFindTypeChange = (val) => {
    setInqTypeVal(val);
  };


  const handleInputChange = async (e) => {
    setSearchedTxt(e.target.value);
  };

  const handleCountryChange = (val) => {
    setSelectedCountry(val);
  };

  const handleCompanyChange = (val) => {
    setSelectedAssignToMember(val);
  }

  const handleChange = (val) => {
    setDateRange(val);
    if (val) {
      const [fromDate, toDate] = val;

      const formattedFrom = format(fromDate, 'yyyy-MM-dd');
      const formattedTo = format(toDate, 'yyyy-MM-dd');
      setStartDate(formattedFrom);
      setEndDate(formattedTo);

    } else {
      setStartDate("");
      setEndDate("");
    }

  }

  const filterInquiries = () => {
    // console.log("filterInquiries ============= ", startDate, " >>>>>>>>>>>> ", endDate);
    const filterObj = {};
    filterObj.filter_val = searchedTxt;
    filterObj.findWhom = findByOptionVal.value;
    if (props.pageName !== 'MOCK_INQ') {
      filterObj.inq_type = findByInqTypeVal.value;
    }

    filterObj.selected_country = map(country, "label");
    // setFilterData(true);
    filterObj.startDate = startDate;
    filterObj.endDate = endDate;
    filterObj.table_search = "";

    if (props.pageName !== 'MOCK_INQ') {
      if (selectedAssignToMember) {
        filterObj.assign_to_member = selectedAssignToMember.value;
      } else {
        filterObj.assign_to_member = 0;
      }

    }

    if (props.pageName === 'MOCK_INQ') {
      filterObj.limit = admin.LIMIT;
      filterObj.offset = admin.OFFSET;
      Emitter.emit("SET_MOCK_FILTER_INQUIRIES", filterObj);

      setTimeout(() => {
        Emitter.emit("MOCK_FILTER_INQUIRIES", filterObj);
      }, 1000);

    } else {

      Emitter.emit("SET_FILTER_INQUIRIES", filterObj);

      setTimeout(() => {
        Emitter.emit("FILTER_INQUIRIES", filterObj);
      }, 1000);
    }
  };

  const resetFilter = () => {
    const filterObj = {};
    if (props.pageName !== 'MOCK_INQ') {

      if (isViewer) {
        setInqTypeVal(inqType[2]);
        filterObj.inq_type = inqType[2].value;
      } else {
        setInqTypeVal(inqType[1]);
        filterObj.inq_type = inqType[1].value;
      }

    }
    filterObj.findWhom = findByOptions[0].value;
    setFindByOptionVal(findByOptions[0]);
    setPlaceHoderTxt("Search By Company Name, Contact Person, Email, Product, Inquiry ID, Industry/Commodity");
    setSelectedCountry([]);
    setSearchedTxt("");
    setDateRange(null);
    setStartDate("");
    setEndDate("");
    filterObj.filter_val = "";

    filterObj.selected_country = [];

    filterObj.startDate = "";
    filterObj.endDate = "";
    filterObj.table_search = "";
    filterObj.assign_to_member = 0;

    if (selectedAssignToMember) {
      setSelectedAssignToMember(null);
    }

    if (props.pageName === 'MOCK_INQ') {
      filterObj.limit = admin.LIMIT;
      filterObj.offset = admin.OFFSET;
      Emitter.emit("SET_MOCK_FILTER_INQUIRIES", filterObj);

      setTimeout(() => {
        Emitter.emit("MOCK_FILTER_INQUIRIES", filterObj);
      }, 1000);
    } else {
      Emitter.emit("SET_FILTER_INQUIRIES", filterObj);

      setTimeout(() => {
        Emitter.emit("FILTER_INQUIRIES", filterObj);
      }, 1000);
    }

  };

  const fetchMembers = async (val) => {
    try {
      const response = await props.getCompanyListByTradeMode("SUPPLIER,LOG_PTR", val);
      if (response.status === true) {
        setCompanyList(
          map(response.data, (c) => ({
            value: c.id,
            label: c.company_list_name,
            email: c.email,
          }))
        );
      }
    } catch (err) {
      console.error("getCompanyListByTradeMode error:", err);
    }
  };

  const handleMemberInputChange = (val = "") => {
    fetchMembers(val.length >= 3 ? val : "");
  };

  const fetchFilterSelection = async () => {
    const result = await Promise.allSettled([props.getCountryList()]);
    result.forEach((res, indx) => {
      let dataList = [];
      let data = [];
      if (res.status === "fulfilled") {
        if (includes([0, 1, 3], indx)) {
          data = res.value;
        } else if (includes([1, 2], indx)) {
          data = res.value.data;
        }

        if (indx === 0) {
          dataList = data.map((v) => {
            return {
              label: v.name,
              value: v.id,
            };
          });
          setCountryList(dataList);
        }

      } else {
        console.log(
          "Something Went Wrong while fetching index ",
          indx,
          "!! ",
          res.reason
        );
      }
    });

    await fetchMembers("");
  };

  const MoreSelectedBadge = ({ items }) => {
    const style = {
      marginLeft: "auto",
      background: "#d4eefa",
      borderRadius: "4px",
      fontFamily: "Open Sans",
      fontSize: "11px",
      padding: "3px",
      order: 99,
    };

    const title = items.join(", ");
    const length = items.length;
    const label = `+ ${length} item${length !== 1 ? "s" : ""} selected`;

    return (
      <div style={style} title={title}>
        {label}
      </div>
    );
  };

  const MultiValue = ({ index, getValue, ...props }) => {
    const maxToShow = 3;
    const overflow = getValue()
      .slice(maxToShow)
      .map((x) => x.label);

    return index < maxToShow ? (
      <components.MultiValue {...props} />
    ) : index === maxToShow ? (
      <MoreSelectedBadge items={overflow} />
    ) : null;
  };

  const getFilterObj = () => {
    const filterObj = {};
    filterObj.filter_val = searchedTxt;
    if (props.pageName !== 'MOCK_INQ') {
      filterObj.inq_type = findByInqTypeVal.value;
    }
    filterObj.findWhom = findByOptionVal.value;
    filterObj.selected_country = map(country, "label");
    // setFilterData(true);
    filterObj.startDate = startDate;
    filterObj.endDate = endDate;
    if (props.pageName !== 'MOCK_INQ') {
      if (selectedAssignToMember) {
        filterObj.assign_to_member = selectedAssignToMember.value;
      } else {
        filterObj.assign_to_member = 0;
      }

    }

    return filterObj;
  }

  useEffect(() => {

    const fetchData = async () => {
      if (initialFilterRef.current === true) {
        fetchFilterSelection();
        if (props.fordate !== undefined) {
          let fdate = atob(props.fordate);
          console.log("fdate =========", fdate);
          let tdate = new Date();
          if (fdate === 'week') {
            const startOfWeek = moment().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss');

            let weekDates = [new Date(startOfWeek), tdate];
            const formattedFrom = format(new Date(startOfWeek), 'yyyy-MM-dd');
            const formattedTo = format(tdate, 'yyyy-MM-dd');
            setStartDate(formattedFrom);
            setEndDate(formattedTo);
            setDateRange(weekDates);
            let fObj = await getFilterObj();

            fObj.startDate = formattedFrom;
            fObj.endDate = formattedTo;
            Emitter.emit("SET_FILTER_INQUIRIES", fObj);

            setTimeout(() => {
              Emitter.emit("FILTER_INQUIRIES", fObj);
            }, 1000);

          } else if (fdate === 'this_month') {
            
            const startOfMonth = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
            const endOfMonth   = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');

            let todayDate = [new Date(startOfMonth), new Date(endOfMonth)];

            const formattedFrom = format(new Date(startOfMonth), 'yyyy-MM-dd');
            const formattedTo = format(new Date(endOfMonth), 'yyyy-MM-dd');
            setStartDate(formattedFrom);
            setEndDate(formattedTo);
            setDateRange(todayDate);
            let fObj = await getFilterObj();

            fObj.startDate = formattedFrom;
            fObj.endDate = formattedTo;
            Emitter.emit("SET_FILTER_INQUIRIES", fObj);

            setTimeout(() => {
              Emitter.emit("FILTER_INQUIRIES", fObj);
            }, 1000);
          } else if (fdate === 'last_month') {
            let firstDayOfMonth = new Date(tdate.getTime() - 30 * 24 * 60 * 60 * 1000);
            console.log("firstDayOfMonth >>> ", firstDayOfMonth);

            const startOfLastMonth = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD HH:mm:ss');
            const endOfLastMonth   = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD HH:mm:ss');

            let todayDate = [new Date(startOfLastMonth), new Date(endOfLastMonth)];
            const formattedFrom = format(new Date(startOfLastMonth), 'yyyy-MM-dd');
            const formattedTo = format(new Date(endOfLastMonth), 'yyyy-MM-dd');
            setStartDate(formattedFrom);
            setEndDate(formattedTo);
            setDateRange(todayDate);
            let fObj = await getFilterObj();

            fObj.startDate = formattedFrom;
            fObj.endDate = formattedTo;
            Emitter.emit("SET_FILTER_INQUIRIES", fObj);

            setTimeout(() => {
              Emitter.emit("FILTER_INQUIRIES", fObj);
            }, 1000);

          }
        } else {
          console.log("function fetchData called...");
          setStartDate(null);
          setEndDate(null);
          setDateRange(null);
          let fObj = await getFilterObj();

          Emitter.emit("SET_FILTER_INQUIRIES", fObj);
          setTimeout(() => {
            Emitter.emit("FILTER_INQUIRIES", fObj);
          }, 1000);


        }

        initialFilterRef.current = false;
      }
    }

    fetchData();

  }, [initialFilterRef]);

  return (
    <div className="bg-white shadow rounded mb-4">
      <div className="buyer-suplier-search-section member-filter all-admin-inquiry">
        {(props.pageName !== 'MOCK_INQ' && (props.pageName !== "ADMIN_INQ") ) && (
          <div className="buyer-suplier-section-child all">
            <DropDown
              placeholder="Select.."
              options={inqType}
              value={findByInqTypeVal}
              onChange={handleFindTypeChange}
              menuPlacement="bottom"
            />
          </div>
        )}
        {
          <div className="buyer-suplier-section-child all">
            <DropDown
              placeholder="Select.."
              options={findByOptions}
              value={findByOptionVal}
              onChange={handleFindByChange}
              menuPlacement="bottom"
            />
          </div>
        }

        {
          (props.pageName !== 'MOCK_INQ') && <div className="buyer-suplier-section-child assign_to_company">
            <ReactSelect
              options={companyList}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              components={{
                Option: CustomOption,
                IndicatorSeparator: () => null,
                MultiValue,
              }}
              onChange={handleCompanyChange}
              value={selectedAssignToMember}
              removeSelected={false}
              styles={customStyles}
              placeholder="Select assign-to company"
              className="member-filter-container"
              classNamePrefix="member-filter-select"
              noOptionsMessage={() => "No Company Found"}
              onInputChange={handleMemberInputChange}
              filterOption={customMemberFilter}
            />
          </div>
        }



        <div className="buyer-suplier-section-child country">
          <ReactSelect
            options={countryList}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option: CustomOption,
              IndicatorSeparator: () => null,
              MultiValue,
            }}
            onChange={handleCountryChange}
            value={country}
            removeSelected={false}
            styles={customStyles}
            placeholder="Select country"
            className="member-filter-container"
            classNamePrefix="member-filter-select"
            noOptionsMessage={() => "No Country Found"}
          />
        </div>

        <div className="buyer-suplier-section-child date-range">

          <DateRangePickerField
            value={dateRange}
            onChange={handleChange}
            defaultCalendarValue={defaultCalendarValue}
          />

        </div>

        <div className="buyer-suplier-section-child search">

          <div className="d-flex align-items-center w-100">
            <InputField
              type="text"
              id="filter-text-box"
              placeholder="Search Keywords"
              className="w-25"
              onChange={handleInputChange}
              value={searchedTxt}
              autoComplete="off"
            ></InputField>

            <ToolipsCustom
              title={"?"}
              subtitle={placehoderTxt}
            >
            </ToolipsCustom>


          </div>




        </div>

        <div className="filter-search-btn search-btn">
          <ButtonAdminpanel type="button" onClick={filterInquiries}>
            {" "}
            <i className="fa-solid fa-magnifying-glass text-white"></i> Search{" "}
          </ButtonAdminpanel>

          <button
            type="button"
            className=" btn filter-reset-btn mx-2"
            onClick={resetFilter}
          >
            <svg
              viewBox="0 0 21 21"
              xmlns="http://www.w3.org/2000/svg"
              fill="#000000"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <g
                  fill="none"
                  fillRule="evenodd"
                  stroke="#000000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  transform="matrix(0 1 1 0 2.5 2.5)"
                >
                  {" "}
                  <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"></path>{" "}
                  <path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"></path>{" "}
                </g>{" "}
              </g>
            </svg>
            Reset
          </button>
          {
            (isSuperAdmin || isViewer || isInqUser) && <ButtonAdd
              type="button"
              className="btn-add me-0"
              onClick={props.handleClick}
            >
              {" "}
              <i className="fa-solid fa-circle-plus"></i> Add Inquiry
            </ButtonAdd>
          }
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCountryList: () => dispatch(getCountryList()),
    getCompanyListByTradeMode: (trade_mode, searchtxt) => dispatch(getCompanyListByTradeMode(trade_mode, searchtxt))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(AllAdminInquiriesFilter));
